import React from 'react'
import { Helmet } from 'react-helmet-async'

interface Props {
  offer: App.BedbankOffer;
}

function HotelStructuredData(props: Props) {
  const { offer } = props

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Hotel',
    name: offer.name,
    description: offer.metaDescription,
    address: {
      '@type': 'PostalAddress',
      addressCountry: offer.property.address.countryCode,
      addressRegion: offer.property.address.stateProvinceName,
      addressLocality: offer.property.address.city,
      postalCode: offer.property.address.postalCode,
      streetAddress: offer.property.address.line1 + (offer.property.address.line2 ? ' ' + offer.property.address.line2 : ''),
    },
    telephone: offer.property.phone,
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  )
}

export default React.memo(HotelStructuredData)
